export default "__VITE_ASSET__10e833e3__"